import { IProduct } from "@pbm/discount-rules/contracts";

interface ProductsListProps {
  data: IProduct[];
}

export function ProductsList({ data }: ProductsListProps) {
  return (
    <div className="flex flex-col w-full">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    EAN
                  </th>

                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Nome
                  </th>

                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Apresentação
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {data.map((item) => (
                  <tr
                    key={item.ean}
                    className="border border-t border-gray-200"
                  >
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">
                      {item.ean}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">
                      {item.name}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">
                      {item.package}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
